import React from 'react';
import { LoadingSpinner } from './LoadingSpinner';
import { STYLES } from '../../constants/styles';
import { classNames, variantClass } from '../../utils/classNames';

interface BaseButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  variant?: 'primary' | 'secondary' | 'danger';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  type?: 'button' | 'submit' | 'reset';
}

export const BaseButton: React.FC<BaseButtonProps> = ({
  children,
  onClick,
  disabled = false,
  loading = false,
  variant = 'primary',
  size = 'md',
  className = '',
  type = 'button'
}) => {
  const buttonClasses = classNames(
    STYLES.BUTTONS.BASE,
    variantClass(variant, {
      primary: STYLES.BUTTONS.PRIMARY,
      secondary: STYLES.BUTTONS.SECONDARY,
      danger: STYLES.BUTTONS.DANGER,
    }),
    variantClass(size, STYLES.BUTTONS.SIZES),
    className
  );

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={buttonClasses}
    >
      {loading && <LoadingSpinner size="sm" />}
      <span>{children}</span>
    </button>
  );
};